// import React, { useState, useEffect } from 'react';
// import {
// 	TextField,
// 	Button,
// 	Container,
// 	Box,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	IconButton,
// 	Autocomplete,
// 	Checkbox,
// 	Typography,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// // import axios from 'axios';
// import { ServiceProduct } from 'types/serviceProduct';
// import { getPlan } from '../../services/api/PlansAPI';
// import Preloader from './Preloader';

// interface ServiceProductFormProps {
// 	serviceProduct?: ServiceProduct;
// 	open: boolean;
// 	handleClose: () => void;
// 	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
// 	planId: string;
// }

// interface PlanFieldStructureDevelop {
// 	label: string;
// 	value: string;
// 	type: string;
// 	_id?: string;
// }

// interface OttApp {
// 	_id: string;
// 	name: string;
// 	imageUrl: string;
// }

// const PlanView: React.FC<ServiceProductFormProps> = ({
// 	serviceProduct,
// 	open,
// 	handleClose,
// 	productNameProvide,
// 	planId,
// }) => {
// 	const [formData, setFormData] = useState<PlanFieldStructureDevelop[]>([]);
// 	const [ottApps, setOttApps] = useState<OttApp[]>([]);
// 	const [selectedOttApps, setSelectedOttApps] = useState<OttApp[]>([]);
// 	const [price, setPrice] = useState<string>('');
// 	const [validity, setValidity] = useState<string>('');
// 	const [offer, setOffer] = useState<string>('');
// 	const [internetSpeed, setInternetSpeed] = useState<string>('');
// 	const [offerImages, setOfferImages] = useState<string[]>([]);
// 	const [preLoaderActive, setPreLoaderActive] = useState(false);
// 	const [responseStatus, setResponseStatus] = useState(true);
// 	const [responseStatusMessage, setResponseStatusMessage] = useState(
// 		'Failed to fetch plan details'
// 	);

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			setPreLoaderActive(true);
// 			try {
// 				// const response = await axios.get('/getPlan.json');
// 				const response = await getPlan(planId);
// 				if (response.success) {
// 					console.log(response.data, 'response');
// 					setPrice(response.data.price.toString());
// 					setOfferImages(response.data.offerImages);
// 					setInternetSpeed(response.data.internetSpeed);
// 					setOffer(response.data.offer);
// 					setValidity(response.data.validity);
// 					setSelectedOttApps(response.data.ottApps);
// 					setOttApps(response.data.ottApps);
// 					setFormData(response.data.fieldValues);
// 				}
// 			} catch (error) {
// 				setResponseStatus(false);
// 				setResponseStatusMessage('Failed to fetch plan details.');
// 				console.log(error);
// 			} finally {
// 				setPreLoaderActive(false);
// 			}
// 		};
// 		fetchData();
// 	}, []);

// 	const handleDialogClose = () => {
// 		handleClose();
// 		handleClose();
// 		setPrice('');
// 		setOfferImages([]);
// 		setInternetSpeed('');

// 		setOffer('');
// 		setValidity('');
// 		setSelectedOttApps([]);
// 		setFormData([]);
// 	};

// 	return (
// 		<Dialog
// 			open={open}
// 			slotProps={{
// 				paper: {
// 					sx: {
// 						minWidth: 300,
// 						maxWidth: 600,
// 						width: '90%',
// 					},
// 				},
// 			}}
// 		>
// 			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
// 				{`View ${productNameProvide} Plan`}
// 				<IconButton
// 					aria-label="close"
// 					onClick={handleDialogClose}
// 					sx={{ position: 'absolute', right: 8, top: 8 }}
// 				>
// 					<CloseIcon />
// 				</IconButton>
// 			</DialogTitle>
// 			<DialogContent>
// 				{/* <Container> */}
// 				{preLoaderActive && <Preloader />}

// 				{!preLoaderActive && (
// 					<Container>
// 						{responseStatus ? (
// 							<Box sx={{ mt: 0 }}>
// 								<form>
// 									<TextField
// 										label="Offer"
// 										value={offer}
// 										fullWidth
// 										margin="normal"
// 										size="small"
// 										slotProps={{
// 											input: {
// 												readOnly: true,
// 											},
// 										}}
// 										disabled
// 									/>

// 									<TextField
// 										label="Price"
// 										value={price}
// 										fullWidth
// 										margin="normal"
// 										size="small"
// 										slotProps={{
// 											input: {
// 												readOnly: true,
// 											},
// 										}}
// 										disabled
// 									/>
// 									{/* {serviceProduct?.isDTH  ? ( */}
// 									{serviceProduct?.isDTH ? (
// 										<div
// 											style={{
// 												marginTop: '15px',
// 												width: '520px',
// 												maxWidth: '600px',
// 												minWidth: '300px',
// 											}}
// 										>
// 											{offerImages.length > 0 && (
// 												<div
// 													style={{
// 														marginTop: '10px',
// 														display: 'flex',
// 														flexWrap: 'wrap',
// 														gap: '3px',
// 													}}
// 												>
// 													{offerImages.map((imageUrl, index) => (
// 														<div
// 															key={index}
// 															style={{
// 																position: 'relative',
// 																width: '250px',
// 																height: '300px',
// 															}}
// 														>
// 															<img
// 																src={imageUrl}
// 																alt={`Preview ${index}`}
// 																style={{
// 																	width: '100%',
// 																	height: '100%',
// 																	objectFit: 'contain',
// 																}}
// 															/>
// 														</div>
// 													))}
// 												</div>
// 											)}
// 										</div>
// 									) : (
// 										<>
// 											<TextField
// 												label="Validity"
// 												value={validity}
// 												fullWidth
// 												margin="normal"
// 												size="small"
// 												slotProps={{
// 													input: {
// 														readOnly: true,
// 													},
// 												}}
// 												disabled
// 											/>
// 											<TextField
// 												label="Internet Speed"
// 												value={internetSpeed}
// 												fullWidth
// 												margin="normal"
// 												size="small"
// 												slotProps={{
// 													input: {
// 														readOnly: true,
// 													},
// 												}}
// 												disabled
// 											/>
// 											{formData.map((field, index) => (
// 												<TextField
// 													key={index}
// 													label={field.label}
// 													value={field.value}
// 													fullWidth
// 													margin="normal"
// 													size="small"
// 													slotProps={{
// 														input: {
// 															readOnly: true,
// 														},
// 													}}
// 													disabled
// 												/>
// 											))}
// 											<Autocomplete
// 												multiple
// 												options={ottApps}
// 												getOptionLabel={(option) => option.name}
// 												value={selectedOttApps}
// 												disableClearable
// 												renderOption={(props, option, { selected }) => (
// 													<li {...props}>
// 														<Checkbox checked={selected} />
// 														<img
// 															src={option.imageUrl}
// 															alt={option.name}
// 															style={{
// 																width: 20,
// 																height: 20,
// 																marginRight: 10,
// 															}}
// 														/>
// 														{option.name}
// 													</li>
// 												)}
// 												renderTags={(tagValue) =>
// 													tagValue.map((option, index) => (
// 														<div
// 															key={index}
// 															style={{
// 																display: 'flex',
// 																alignItems: 'center',
// 																backgroundColor: '#7159c1',
// 																borderRadius: 20,
// 																padding: '4px 10px',
// 																marginRight: 5,
// 																color: 'white',
// 																marginBottom: 5,
// 															}}
// 														>
// 															<img
// 																src={option.imageUrl}
// 																alt={option.name}
// 																style={{
// 																	width: 20,
// 																	height: 20,
// 																	borderRadius: '50%',
// 																	marginRight: 6,
// 																}}
// 															/>
// 															<span style={{ marginRight: 6 }}>
// 																{option.name}
// 															</span>
// 														</div>
// 													))
// 												}
// 												renderInput={(params) => (
// 													<TextField
// 														{...params}
// 														label="OTT Apps"
// 														placeholder="Search OTT Apps"
// 														slotProps={{
// 															input: {
// 																readOnly: true,
// 															},
// 														}}
// 														disabled
// 														style={{ marginTop: '10px' }}
// 													/>
// 												)}
// 											/>
// 										</>
// 									)}
// 									<DialogActions>
// 										<Button
// 											onClick={handleDialogClose}
// 											color="secondary"
// 											variant="outlined"
// 										>
// 											Close
// 										</Button>
// 									</DialogActions>
// 								</form>
// 							</Box>
// 						) : (
// 							<Box sx={{ mt: 0 }}>
// 								<Typography
// 									variant="h6"
// 									sx={{
// 										mt: 2,
// 										textAlign: 'center',
// 										color: 'red',
// 										fontWeight: 'bold',
// 										height: '200px',
// 										display: 'flex',
// 										alignItems: 'center',
// 										justifyContent: 'center',
// 									}}
// 								>
// 									{responseStatusMessage}
// 								</Typography>
// 							</Box>
// 						)}
// 					</Container>
// 				)}
// 			</DialogContent>
// 		</Dialog>
// 	);
// };

// export default PlanView;
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
// ==========================================================
import React, { useState, useEffect } from 'react';
import {
	TextField,
	Button,
	Container,
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Autocomplete,
	Checkbox,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ServiceProduct } from 'types/serviceProduct';
import { getPlan } from '../../services/api/PlansAPI';
import Preloader from './Preloader';

interface ServiceProductFormProps {
	serviceProduct?: ServiceProduct;
	open: boolean;
	handleClose: () => void;
	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
	planId: string;
}

interface PlanFieldStructureDevelop {
	label: string;
	value: string;
	type: string;
	_id?: string;
}

interface OttApp {
	_id: string;
	name: string;
	imageUrl: string;
}

const PlanView: React.FC<ServiceProductFormProps> = ({
	serviceProduct,
	open,
	handleClose,
	productNameProvide,
	planId,
}) => {
	const [formData, setFormData] = useState<PlanFieldStructureDevelop[]>([]);
	const [ottApps, setOttApps] = useState<OttApp[]>([]);
	const [selectedOttApps, setSelectedOttApps] = useState<OttApp[]>([]);
	const [price, setPrice] = useState<string>('');
	const [validity, setValidity] = useState<string>('');
	const [offer, setOffer] = useState<string>('');
	const [internetSpeed, setInternetSpeed] = useState<string>('');
	const [offerImages, setOfferImages] = useState<string[]>([]);
	const [preLoaderActive, setPreLoaderActive] = useState(false);
	const [responseStatus, setResponseStatus] = useState(true);
	const [responseStatusMessage, setResponseStatusMessage] = useState(
		'Failed to fetch plan details'
	);

	useEffect(() => {
		const fetchData = async () => {
			setPreLoaderActive(true);
			try {
				const response = await getPlan(planId);
				if (response.success) {
					console.log(response.data, 'response');
					setPrice(response.data.price.toString());
					setOfferImages(response.data.offerImages);
					setInternetSpeed(response.data.internetSpeed);
					setOffer(response.data.offer);
					setValidity(response.data.validity);
					setSelectedOttApps(response.data.ottApps);
					setOttApps(response.data.ottApps);
					setFormData(response.data.fieldValues);
				}
			} catch (error) {
				setResponseStatus(false);
				setResponseStatusMessage('Failed to fetch plan details.');
				console.log(error);
			} finally {
				setPreLoaderActive(false);
			}
		};
		fetchData();
	}, []);

	const handleDialogClose = () => {
		handleClose();
		setPrice('');
		setOfferImages([]);
		setInternetSpeed('');
		setOffer('');
		setValidity('');
		setSelectedOttApps([]);
		setFormData([]);
	};
	const handleToggleOttApp = (app: OttApp) => {
		setSelectedOttApps((prevSelected) => {
			if (prevSelected.some((selectedApp) => selectedApp._id === app._id)) {
				return prevSelected.filter((selectedApp) => selectedApp._id !== app._id);
			} else {
				return [...prevSelected, app];
			}
		});
	};
	const filteredSelectedOttApps = selectedOttApps.filter((selectedApp) =>
		ottApps.some((app) => app._id === selectedApp._id)
	);
	return (
		<Dialog
			open={open}
			slotProps={{
				paper: {
					sx: {
						minWidth: 300,
						maxWidth: 600,
						width: '90%',
					},
				},
			}}
		>
			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
				{`View ${productNameProvide} Plan`}
				<IconButton
					aria-label="close"
					onClick={handleDialogClose}
					sx={{ position: 'absolute', right: 8, top: 8 }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				{preLoaderActive && <Preloader />}

				{!preLoaderActive && (
					<Container>
						{responseStatus ? (
							<Box sx={{ mt: 0 }}>
								<form>
									<TextField
										label="Offer"
										value={offer}
										fullWidth
										margin="normal"
										size="small"
										slotProps={{
											input: {
												readOnly: true,
											},
										}}
										disabled
									/>

									<TextField
										label="Price"
										value={price}
										fullWidth
										margin="normal"
										size="small"
										slotProps={{
											input: {
												readOnly: true,
											},
										}}
										disabled
									/>
									{serviceProduct?.isDTH ? (
										<div
											style={{
												marginTop: '15px',
												width: '520px',
												maxWidth: '600px',
												minWidth: '300px',
											}}
										>
											{offerImages.length > 0 && (
												<div
													style={{
														marginTop: '10px',
														display: 'flex',
														flexWrap: 'wrap',
														gap: '3px',
													}}
												>
													{offerImages.map((imageUrl, index) => (
														<div
															key={index}
															style={{
																position: 'relative',
																width: '250px',
																height: '300px',
															}}
														>
															<img
																src={imageUrl}
																alt={`Preview ${index}`}
																style={{
																	width: '100%',
																	height: '100%',
																	objectFit: 'contain',
																}}
															/>
														</div>
													))}
												</div>
											)}
										</div>
									) : (
										<>
											<TextField
												label="Validity"
												value={validity}
												fullWidth
												margin="normal"
												size="small"
												slotProps={{
													input: {
														readOnly: true,
													},
												}}
												disabled
											/>
											<TextField
												label="Internet Speed"
												value={internetSpeed}
												fullWidth
												margin="normal"
												size="small"
												slotProps={{
													input: {
														readOnly: true,
													},
												}}
												disabled
											/>
											{formData.map((field, index) => (
												<TextField
													key={index}
													label={field.label}
													value={field.value}
													fullWidth
													margin="normal"
													size="small"
													slotProps={{
														input: {
															readOnly: true,
														},
													}}
													disabled
												/>
											))}
											{/* <Autocomplete
												multiple
												options={ottApps}
												getOptionLabel={(option) => option.name}
												value={selectedOttApps}
												disableClearable
												renderOption={(props, option) => {
													const selected = selectedOttApps.some(
														(selectedApp) =>
															selectedApp._id === option._id
													);
													return (
														<li {...props}>
															<Checkbox checked={selected} />
															<img
																src={option.imageUrl}
																alt={option.name}
																style={{
																	width: 20,
																	height: 20,
																	marginRight: 10,
																}}
															/>
															{option.name}
														</li>
													);
												}}
												renderTags={(tagValue) =>
													tagValue.map((option, index) => (
														<div
															key={index}
															style={{
																display: 'flex',
																alignItems: 'center',
																backgroundColor: '#7159c1',
																borderRadius: 20,
																padding: '4px 10px',
																marginRight: 5,
																color: 'white',
																marginBottom: 5,
															}}
														>
															<img
																src={option.imageUrl}
																alt={option.name}
																style={{
																	width: 20,
																	height: 20,
																	borderRadius: '50%',
																	marginRight: 6,
																}}
															/>
															<span style={{ marginRight: 6 }}>
																{option.name}
															</span>
														</div>
													))
												}
												renderInput={(params) => (
													<TextField
														{...params}
														label="OTT Apps"
														placeholder="Search OTT Apps"
														slotProps={{
															input: {
																readOnly: true,
															},
														}}
														disabled
														style={{ marginTop: '10px' }}
													/>
												)}
											/> */}
											<Autocomplete
												multiple
												options={ottApps}
												getOptionLabel={(option) => option.name}
												value={filteredSelectedOttApps}
												onChange={(event, newValue) => {
													setSelectedOttApps(newValue);
												}}
												disableClearable
												renderOption={(props, option) => {
													const selected = selectedOttApps.some(
														(selectedApp) =>
															selectedApp._id === option._id
													);
													return (
														<li
															{...props}
															onClick={() =>
																handleToggleOttApp(option)
															}
														>
															<Checkbox checked={selected} />
															<img
																src={option.imageUrl}
																alt={option.name}
																style={{
																	width: 20,
																	height: 20,
																	marginRight: 10,
																}}
															/>
															{option.name}
														</li>
													);
												}}
												renderTags={(tagValue) =>
													tagValue.map((option, index) => (
														<div
															key={index}
															style={{
																display: 'flex',
																alignItems: 'center',
																backgroundColor: '#7159c1',
																borderRadius: 20,
																padding: '4px 10px',
																marginRight: 5,
																color: 'white',
																marginBottom: 5,
															}}
														>
															<img
																src={option.imageUrl}
																alt={option.name}
																style={{
																	width: 20,
																	height: 20,
																	borderRadius: '50%',
																	marginRight: 6,
																}}
															/>
															<span style={{ marginRight: 6 }}>
																{option.name}
															</span>
															{/* <IconButton
																size="small"
																onClick={() => {
																	const newTags =
																		selectedOttApps.filter(
																			(item) =>
																				item._id !==
																				option._id
																		);
																	setSelectedOttApps(newTags);
																}}
																sx={{
																	color: 'white',
																	backgroundColor: '#ccc',
																	'&:hover': {
																		backgroundColor:
																			'primary.main',
																	},
																}}
															>
																<CloseIcon fontSize="small" />
															</IconButton> */}
														</div>
													))
												}
												renderInput={(params) => (
													<TextField
														{...params}
														label="OTT Apps"
														placeholder="Search OTT Apps"
													/>
												)}
											/>
										</>
									)}
									<DialogActions>
										<Button
											onClick={handleDialogClose}
											color="secondary"
											variant="outlined"
										>
											Close
										</Button>
									</DialogActions>
								</form>
							</Box>
						) : (
							<Box sx={{ mt: 0 }}>
								<Typography
									variant="h6"
									sx={{
										mt: 2,
										textAlign: 'center',
										color: 'red',
										fontWeight: 'bold',
										height: '200px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									{responseStatusMessage}
								</Typography>
							</Box>
						)}
					</Container>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default PlanView;
